


import React, { Fragment } from "react";
import { ConfigInterface } from "swr";
import { useAudit } from "../../data/audits/audit/useAudit";
import IAudit from "../../interfaces/IAudit";

type IRenderProps = { audit: IAudit | null };

interface RenderAuditProps {
    auditGuid: IAudit["guid"];
    render: (props: IRenderProps) => any;
    config?: ConfigInterface<IAudit | null>
};

export const RenderAudit: React.FC<RenderAuditProps> = ({ auditGuid, render, config = {} }) => {
    const { data: audit } = useAudit(auditGuid, config);
    return (
        <Fragment>
            {render({ audit })}
        </Fragment>
    );
};

